<!-- <select
  class="form-select shadow-none"
  [name]="name"
  [formControlName]="formControlName"
  (change)="onChange($event.target)"
>
  <option
    *ngFor="let option of selectList | keyvalue : originalOrder"
    [value]="option.key"
  >
    {{ option.value }}
  </option>
</select> -->

<ng-select
  class="shadow-none"
  [formControlName]="formControlName"
  [clearable]="true"
  [selectOnTab]="true"
  [notFoundText]="notFoundText"
  (change)="onChange($event)"
>
  <ng-option
    *ngFor="let option of selectList | keyvalue : originalOrder"
    [value]="option.key"
  >
    {{ option.value }}</ng-option
  >
</ng-select>
